export default "__VITE_ASSET__a7e73ce1__"